import React from 'react'

export const Ticino = ({ fill }) => (
<svg version="1.1" width="45.1748px" height="68.0892px" viewBox="0 0 45.1748 68.0892">
<g fill={fill}>
	<g>
		<path class="st0" d="M29.7426,16.6697c-0.126,0-0.2529-0.0239-0.376-0.0737c-0.5117-0.2075-0.7578-0.791-0.5508-1.3027
			C32.1557,7.0599,39.1313,2.9671,39.4272,2.7972c0.4766-0.2739,1.0879-0.1123,1.3643,0.3662
			c0.2764,0.4775,0.1123,1.0894-0.3652,1.3657c-0.0664,0.0386-6.6836,3.9399-9.7568,11.5161
			C30.5111,16.4339,30.1371,16.6697,29.7426,16.6697z"/>
	</g>
	<g>
		<path class="st0" d="M30.1166,15.8196c-0.1562,0-0.3154-0.0366-0.4639-0.1147c-0.4893-0.2563-0.6777-0.8608-0.4209-1.3501
			c2.2656-4.3164,2.0459-8.1255-0.6016-10.4497c-1.5605-1.3735-3.5898-1.1831-5.0488,0.4741
			c-0.3584,0.4097-0.5273,0.9404-0.4746,1.4917c0.0518,0.5415,0.3115,1.02,0.7324,1.3477c0.4541,0.3516,0.6943,0.5493,0.8672,0.6909
			c0.2402,0.1973,0.332,0.272,0.7891,0.5732c0.4619,0.3037,0.5889,0.9238,0.2852,1.3853c-0.3037,0.4604-0.9238,0.5903-1.3848,0.2847
			c-0.5557-0.3657-0.667-0.458-0.958-0.6973c-0.1641-0.1348-0.3926-0.3218-0.8252-0.6572
			c-0.8486-0.6606-1.3936-1.6582-1.4971-2.7368c-0.1045-1.0889,0.2471-2.1831,0.9629-3.0015
			c2.1836-2.4766,5.4922-2.75,7.8721-0.6572c3.3984,2.9839,3.7822,7.6792,1.0527,12.8818
			C30.8246,15.6248,30.477,15.8196,30.1166,15.8196z"/>
	</g>
	<g>
		<g>
			<path class="st0" d="M6.7992,33.4358c-0.9775,0-1.9521-0.2139-2.8652-0.6387c-3.4014-1.582-4.8818-5.6367-3.2998-9.0386
				c1.582-3.4009,5.6348-4.8823,9.0391-3.2988c3.4004,1.583,4.8799,5.6377,3.2988,9.0391c-0.001,0-0.001,0-0.001,0
				c-0.7666,1.6475-2.1289,2.8979-3.8359,3.521C8.3744,33.2977,7.5863,33.4358,6.7992,33.4358z M6.8109,21.8255
				c-1.8115,0-3.5488,1.0288-4.3633,2.7769c-1.1162,2.4019-0.0713,5.2646,2.3301,6.3813c1.1621,0.541,2.4658,0.5962,3.6719,0.1577
				c1.2051-0.4399,2.167-1.3232,2.709-2.4863c1.1162-2.4014,0.0713-5.2642-2.3291-6.3818
				C8.1762,21.969,7.4887,21.8255,6.8109,21.8255z"/>
		</g>
		<g>
			<path class="st0" d="M17.3207,38.3323c-0.9775,0-1.9521-0.2139-2.8652-0.6377c-3.4014-1.584-4.8799-5.6392-3.2969-9.0396
				c0.7656-1.6475,2.1279-2.8984,3.835-3.5215c1.7061-0.6226,3.5547-0.5439,5.2021,0.2227
				c1.6475,0.7671,2.8984,2.1294,3.5215,3.8364s0.5439,3.5547-0.2236,5.2021c-0.7656,1.6475-2.1279,2.8984-3.835,3.5215
				C18.8969,38.1937,18.1078,38.3323,17.3207,38.3323z M17.3295,26.719c-0.5557,0-1.1123,0.0972-1.6504,0.2935
				c-1.2051,0.4399-2.167,1.3228-2.707,2.4863c-1.1182,2.4009-0.0732,5.2637,2.3271,6.3823c1.165,0.542,2.4697,0.5967,3.6729,0.1562
				c1.2061-0.4399,2.168-1.3228,2.708-2.4863c0.001,0,0.001,0,0.001,0c1.1172-2.4014,0.0723-5.2637-2.3291-6.3813
				C18.7074,26.8699,18.0189,26.719,17.3295,26.719z"/>
		</g>
		<g>
			<path class="st0" d="M27.8373,43.2239c-0.959,0-1.9326-0.2041-2.8584-0.6338c-3.4004-1.584-4.8799-5.6377-3.2988-9.0391
				c1.584-3.4014,5.6396-4.8799,9.0391-3.2988c1.6475,0.7666,2.8984,2.1289,3.5215,3.8364c0.623,1.7065,0.5439,3.5542-0.2236,5.2017
				l0,0C32.8656,41.7659,30.4037,43.2239,27.8373,43.2239z M27.8568,31.6175c-1.8115,0-3.5498,1.0293-4.3633,2.7773
				c-1.1162,2.4014-0.0713,5.2637,2.3291,6.3818c2.4023,1.1172,5.2646,0.0713,6.3818-2.3301l0,0
				c0.541-1.1631,0.5967-2.4668,0.1572-3.6724s-1.3232-2.1675-2.4863-2.7085C29.2221,31.7615,28.5346,31.6175,27.8568,31.6175z"/>
		</g>
		<g>
			<path class="st0" d="M38.3617,48.1194c-0.96,0-1.9336-0.2041-2.8594-0.6348c-1.6475-0.7656-2.8984-2.1279-3.5215-3.835
				c-0.623-1.708-0.5439-3.5557,0.2236-5.2031c1.582-3.4014,5.6338-4.8818,9.0381-3.2993c3.4004,1.5845,4.8799,5.6392,3.2979,9.0386
				l0,0C43.3891,46.6614,40.9272,48.1194,38.3617,48.1194z M38.3813,36.513c-1.8115,0-3.5498,1.0293-4.3643,2.7773
				c-0.541,1.1631-0.5967,2.4678-0.1572,3.6729c0.4395,1.2061,1.3232,2.167,2.4863,2.708c2.3994,1.1191,5.2637,0.0732,6.3818-2.3291
				c1.1162-2.4004,0.0713-5.2627-2.3291-6.3818C39.7455,36.6565,39.058,36.513,38.3813,36.513z"/>
		</g>
	</g>
	<g>
		<g>
			<path class="st0" d="M16.2885,26.7786c-0.96,0-1.9336-0.2041-2.8594-0.6348c-1.6475-0.7661-2.8984-2.1284-3.5205-3.8359
				c-0.623-1.707-0.5439-3.5542,0.2227-5.2017c1.582-3.4004,5.6338-4.8823,9.0381-3.2988c1.6475,0.7661,2.8984,2.1284,3.5215,3.8355
				s0.5439,3.5547-0.2236,5.2021l0,0C21.3158,25.3206,18.8539,26.7786,16.2885,26.7786z M16.307,15.1731
				c-1.8115,0-3.5498,1.0293-4.3633,2.7769c-0.541,1.1631-0.5967,2.4673-0.1572,3.6724c0.4404,1.2056,1.3232,2.167,2.4863,2.708
				c2.3994,1.1167,5.2637,0.0728,6.3818-2.3291l0,0c0.541-1.1631,0.5967-2.4673,0.1572-3.6724
				c-0.4395-1.2056-1.3232-2.167-2.4863-2.708C17.6723,15.3172,16.9848,15.1731,16.307,15.1731z"/>
		</g>
		<g>
			<path class="st0" d="M26.8188,31.6785c-0.9785,0-1.9531-0.2139-2.8662-0.6387c-1.6484-0.7666-2.8984-2.1289-3.5215-3.8359
				s-0.5439-3.5547,0.2236-5.2026c1.582-3.3994,5.6348-4.8799,9.0371-3.2983c3.4004,1.5835,4.8809,5.6377,3.2998,9.0386
				c-0.001,0-0.001,0-0.001,0c-0.7666,1.6479-2.1289,2.8984-3.8359,3.5215C28.3939,31.5403,27.6059,31.6785,26.8188,31.6785z
				 M26.8305,20.0687c-1.8115,0-3.5498,1.0288-4.3633,2.7764c-0.541,1.1636-0.5977,2.4683-0.1572,3.6733
				c0.4395,1.2051,1.3223,2.167,2.4863,2.708c2.4023,1.1182,5.2637,0.0718,6.3818-2.3286c1.1162-2.4009,0.0713-5.2637-2.3301-6.3813
				C28.1947,20.2127,27.5072,20.0687,26.8305,20.0687z"/>
		</g>
		<g>
			<path class="st0" d="M37.3412,36.5745c-0.9785,0-1.9521-0.2129-2.8652-0.6387c-1.6484-0.7666-2.8984-2.1289-3.5215-3.8359
				c-0.6231-1.707-0.5439-3.5542,0.2236-5.2021c0.7656-1.6475,2.1279-2.8984,3.835-3.5215c1.708-0.6221,3.5557-0.5425,5.2021,0.2231
				c3.4004,1.583,4.8799,5.6372,3.2969,9.0381c-0.7656,1.6475-2.1279,2.8979-3.835,3.521
				C38.9164,36.4368,38.1273,36.5745,37.3412,36.5745z M37.348,24.9617c-0.5557,0-1.1123,0.0977-1.6494,0.2935
				c-1.2051,0.4399-2.166,1.3228-2.707,2.4863c-0.542,1.1636-0.5977,2.4678-0.1582,3.6729c0.4395,1.2051,1.3223,2.167,2.4863,2.7085
				c1.1631,0.541,2.4668,0.5972,3.6719,0.1572s2.166-1.3232,2.708-2.4863l0,0c1.1172-2.4009,0.0732-5.2637-2.3281-6.3809
				C38.727,25.1126,38.0385,24.9617,37.348,24.9617z"/>
		</g>
	</g>
	<g>
		<g>
			<path class="st0" d="M7.8217,44.9749c-0.959,0-1.9336-0.2031-2.8594-0.6348c-1.6475-0.7656-2.8984-2.1279-3.5205-3.835
				c-0.623-1.707-0.5439-3.5537,0.2217-5.2021c1.584-3.4009,5.6406-4.8799,9.0391-3.2983c3.4004,1.582,4.8809,5.6362,3.2979,9.0376
				l0,0C12.849,43.5179,10.3881,44.9749,7.8217,44.9749z M7.8402,33.3704c-1.8115,0-3.5498,1.0288-4.3633,2.7764
				c-0.541,1.1631-0.5967,2.4678-0.1572,3.6729c0.4404,1.2051,1.3232,2.167,2.4863,2.707c2.3994,1.1201,5.2646,0.0732,6.3818-2.3281
				l0,0c1.1162-2.4014,0.0723-5.2632-2.3291-6.3804C9.2055,33.5145,8.518,33.3704,7.8402,33.3704z"/>
		</g>
		<g>
			<path class="st0" d="M18.352,49.8763c-0.9785,0-1.9531-0.2139-2.8662-0.6396c-3.4014-1.582-4.8809-5.6367-3.2979-9.0381
				c0.7656-1.6475,2.1279-2.8975,3.835-3.5205c1.708-0.6221,3.5557-0.5439,5.2021,0.2236c1.6475,0.7656,2.8984,2.1279,3.5215,3.835
				s0.5439,3.5537-0.2217,5.2021c-0.001,0-0.001,0-0.001,0c-0.7666,1.6475-2.1289,2.8984-3.8359,3.5215
				C19.9272,49.7376,19.1381,49.8763,18.352,49.8763z M18.3568,38.263c-0.5547,0-1.1113,0.0977-1.6484,0.2939
				c-1.2051,0.4395-2.167,1.3223-2.708,2.4854c-1.1172,2.4014-0.0723,5.2637,2.3291,6.3818
				c1.1621,0.541,2.4678,0.5967,3.6729,0.1572s2.167-1.3232,2.709-2.4863c0.541-1.1631,0.5967-2.4678,0.1562-3.6729
				c-0.4395-1.2051-1.3232-2.166-2.4863-2.707C19.7367,38.4144,19.0482,38.263,18.3568,38.263z"/>
		</g>
		<g>
			<path class="st0" d="M28.8686,54.7679c-0.96,0-1.9336-0.2041-2.8594-0.6338c-1.6475-0.7676-2.8984-2.1299-3.5215-3.8369
				s-0.5439-3.5547,0.2236-5.2021c0.7656-1.6475,2.1279-2.8984,3.835-3.5215s3.5547-0.5439,5.2021,0.2236
				c3.4004,1.582,4.8799,5.6367,3.2988,9.0381c-0.001,0-0.001,0-0.001,0C33.8949,53.3099,31.434,54.7679,28.8686,54.7679z
				 M28.8813,43.1585c-0.5557,0-1.1123,0.0977-1.6494,0.2939c-1.2051,0.4395-2.166,1.3232-2.707,2.4863
				c-1.1182,2.4014-0.0732,5.2637,2.3281,6.3818c2.4004,1.1162,5.2627,0.0732,6.3809-2.3291
				c1.1162-2.4014,0.0713-5.2637-2.3291-6.3818C30.2602,43.3099,29.5717,43.1585,28.8813,43.1585z"/>
		</g>
	</g>
	<g>
		<g>
			<path class="st0" d="M8.8568,56.5267c-0.9785,0-1.9531-0.2139-2.8662-0.6396c-1.6475-0.7656-2.8975-2.127-3.5205-3.835
				c-0.623-1.707-0.5439-3.5547,0.2217-5.2021c0.7676-1.6484,2.1299-2.8984,3.8369-3.5215c1.708-0.623,3.5537-0.5449,5.2021,0.2236
				c1.6475,0.7666,2.8984,2.1289,3.5215,3.835c0.623,1.707,0.5439,3.5547-0.2236,5.2021c-0.7666,1.6475-2.1289,2.8984-3.8359,3.5215
				C10.432,56.388,9.643,56.5267,8.8568,56.5267z M8.8627,44.9134c-0.5547,0-1.1113,0.0977-1.6484,0.2939
				c-1.2051,0.4395-2.167,1.3223-2.709,2.4863c-0.541,1.1631-0.5967,2.4678-0.1562,3.6729c0.4395,1.2051,1.3223,2.167,2.4854,2.707
				c1.1611,0.542,2.4658,0.5986,3.6729,0.1582c1.2051-0.4395,2.167-1.3232,2.709-2.4863c1.1172-2.4004,0.0723-5.2627-2.3291-6.3809
				C10.2416,45.0647,9.5531,44.9134,8.8627,44.9134z"/>
		</g>
		<g>
			<path class="st0" d="M19.3803,61.4231c-0.9785,0-1.9531-0.2139-2.8662-0.6396c-1.6475-0.7656-2.8984-2.1279-3.5215-3.835
				c-0.623-1.708-0.5439-3.5557,0.2236-5.2031c1.582-3.4004,5.6348-4.8799,9.0371-3.2979c3.4014,1.582,4.8809,5.6367,3.2979,9.0381
				c-0.7656,1.6475-2.1279,2.8984-3.835,3.5215C20.9555,61.2845,20.1664,61.4231,19.3803,61.4231z M19.391,49.8128
				c-1.8115,0-3.5488,1.0283-4.3623,2.7764c-0.541,1.1631-0.5967,2.4678-0.1572,3.6729c0.4395,1.2061,1.3232,2.167,2.4863,2.708
				c1.1621,0.543,2.4678,0.5977,3.6729,0.1582s2.167-1.3232,2.707-2.4863c0.001,0,0.001,0,0.001,0
				c1.1172-2.4014,0.0723-5.2637-2.3291-6.3818C20.7563,49.9563,20.0688,49.8128,19.391,49.8128z"/>
		</g>
	</g>
	<g>
		<path class="st0" d="M9.8773,68.0892c-0.9785,0-1.9521-0.2139-2.8662-0.6377c-1.6475-0.7676-2.8984-2.1299-3.5215-3.8369
			c-0.623-1.707-0.5439-3.5547,0.2236-5.2021c1.584-3.3994,5.6387-4.8789,9.0381-3.2979c3.4004,1.583,4.8799,5.6367,3.2988,9.0381
			c-0.7666,1.6475-2.1289,2.8984-3.8369,3.5205C11.4525,67.9515,10.6635,68.0892,9.8773,68.0892z M9.8891,56.4798
			c-1.8115,0-3.5488,1.0283-4.3633,2.7764c-0.541,1.1631-0.5967,2.4678-0.1572,3.6729c0.4395,1.2051,1.3232,2.167,2.4863,2.709
			c1.1631,0.541,2.4658,0.5947,3.6738,0.1572c1.2051-0.4404,2.167-1.3232,2.707-2.4863c1.1172-2.4014,0.0723-5.2637-2.3281-6.3818
			C11.2543,56.6233,10.5668,56.4798,9.8891,56.4798z"/>
	</g>
</g>
</svg>
)

